import { Link } from "react-router-dom";

export const LogoMark = ({ size = 36, dark = false, className = "" }) => (
  <img
    src={dark ? "/rd-monogram-dark.png" : "/rd-monogram.png"}
    alt="RD Cleaning Services logo"
    style={{ height: size, width: "auto" }}
    className={className}
    data-testid="logo-mark"
  />
);

export const Logo = ({ dark = false }) => (
  <Link
    to="/"
    className="focus-ring flex shrink-0 items-center rounded-md"
    style={{ gap: 11 }}
    data-testid="logo-link"
    aria-label="RD Cleaning Services home"
  >
    <img
      src={dark ? "/rd-monogram-dark.png" : "/rd-monogram.png"}
      alt="RD Cleaning Services logo"
      className="h-10 w-auto md:h-12"
      data-testid="logo-image"
    />
    <span
      className="whitespace-nowrap font-display text-[15px] font-bold leading-none md:text-[18.5px]"
      style={{ color: dark ? "#FFFFFF" : "#0B1F3A", letterSpacing: "-0.01em" }}
      data-testid="logo-wordmark"
    >
      RD Cleaning Services
    </span>
  </Link>
);
